/**
 * Homepage: gender category rows (native scroll) + featured collections (Flickity tabs).
 */
(function () {
  if (!window.skLocaleFetchInit && window.fetch && window.skLocale) {
    window.skLocaleFetchInit = true;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (window.skLocale.isEnglish && url && url.indexOf('view=recently-viewed-products') !== -1 && url.indexOf('locale=') === -1) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + window.skLocale.localeParam;
        input = typeof input === 'string' ? url : new Request(url, input);
      }
      return nativeFetch(input, init);
    };
  }

  var GENDER_SECTION = '[data-sk-collection-gender]';
  var FLICKITY_SECTION = '[data-sk-featured-collections]';
  var GENDER_PANEL = '[data-sk-gender-panel]';
  var FEATURED_PANEL = '[data-sk-featured-panel]';

  /* ==========================================================================
     Gender collection tabs — horizontal scroll (no Flickity)
     ========================================================================== */

  function getGenderActivePanel(section) {
    return (
      section.querySelector(GENDER_PANEL + '.is-active') ||
      section.querySelector(GENDER_PANEL + ':not([hidden])')
    );
  }

  function getGenderActiveTrack(section) {
    var panel = getGenderActivePanel(section);
    return panel ? panel.querySelector('[data-sk-gender-scroll]') : null;
  }

  function getGenderVisibleCols() {
    var w = window.innerWidth;
    if (w >= 1243) return 4;
    if (w >= 1008) return 3;
    if (w >= 641) return 2;
    return 1;
  }

  function getGenderScrollStep(track) {
    var firstItem = track.querySelector('.CollectionItem');
    if (!firstItem) return Math.max(track.clientWidth, 1);
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 12;
    return firstItem.getBoundingClientRect().width + gap;
  }

  function updateGenderScrollNav(section) {
    var track = getGenderActiveTrack(section);
    var prevBtns = section.querySelectorAll('[data-sk-carousel-prev]');
    var nextBtns = section.querySelectorAll('[data-sk-carousel-next]');
    if (!prevBtns.length || !nextBtns.length) return;

    var prevDisabled = true;
    var nextDisabled = true;

    if (track && track.scrollWidth > track.clientWidth + 1) {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var tol = 4;
      prevDisabled = track.scrollLeft <= tol;
      nextDisabled = track.scrollLeft >= maxScroll - tol;
    }

    prevBtns.forEach(function (btn) {
      btn.disabled = prevDisabled;
    });
    nextBtns.forEach(function (btn) {
      btn.disabled = nextDisabled;
    });
  }

  function scrollGenderTrack(section, direction) {
    var track = getGenderActiveTrack(section);
    if (!track) return;

    var step = getGenderScrollStep(track) * getGenderVisibleCols();
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  function bindGenderNav(section) {
    section.querySelectorAll('[data-sk-carousel-nav]').forEach(function (nav) {
      var prevBtn = nav.querySelector('[data-sk-carousel-prev]');
      var nextBtn = nav.querySelector('[data-sk-carousel-next]');
      if (!prevBtn || !nextBtn || prevBtn.dataset.skGenderNavBound === 'true') return;

      prevBtn.dataset.skGenderNavBound = 'true';
      nextBtn.dataset.skGenderNavBound = 'true';

      prevBtn.addEventListener('click', function () {
        scrollGenderTrack(section, -1);
      });

      nextBtn.addEventListener('click', function () {
        scrollGenderTrack(section, 1);
      });
    });
  }

  function switchGenderTab(section, tab) {
    if (tab.classList.contains('is-active')) return;

    var panelId = tab.getAttribute('aria-controls');
    var panel = section.querySelector('#' + panelId);
    if (!panel) return;

    section.querySelectorAll('[data-action="toggle-tab"]').forEach(function (btn) {
      var active = btn === tab;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    section.querySelectorAll(GENDER_PANEL).forEach(function (p) {
      var show = p === panel;
      p.setAttribute('aria-hidden', show ? 'false' : 'true');
      p.hidden = !show;
      p.classList.toggle('is-active', show);

      if (show) {
        hydrateDeferredImages(p);
        var track = p.querySelector('[data-sk-gender-scroll]');
        if (track) track.scrollLeft = 0;
      }
    });

    window.requestAnimationFrame(function () {
      updateGenderScrollNav(section);
    });
  }

  function initGenderScrollSections(scope) {
    var root = scope || document;
    root.querySelectorAll(GENDER_SECTION).forEach(function (section) {
      if (section.dataset.skGenderInit === 'true') return;
      section.dataset.skGenderInit = 'true';

      bindGenderNav(section);

      section.querySelectorAll('[data-action="toggle-tab"]').forEach(function (tab) {
        tab.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            switchGenderTab(section, tab);
          },
          true
        );
      });

      section.querySelectorAll('[data-sk-gender-scroll]').forEach(function (track) {
        if (track.dataset.skScrollBound === 'true') return;
        track.dataset.skScrollBound = 'true';
        track.addEventListener(
          'scroll',
          function () {
            if (getGenderActiveTrack(section) === track) {
              updateGenderScrollNav(section);
            }
          },
          { passive: true }
        );
      });

      updateGenderScrollNav(section);
    });
  }

  function onGenderScrollResize() {
    document.querySelectorAll(GENDER_SECTION).forEach(updateGenderScrollNav);
  }

  /* ==========================================================================
     Featured collections — Flickity tabbed carousels
     ========================================================================== */

  function parseFlickityConfig(el) {
    var raw = el.getAttribute('data-flickity-config');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }

  function getFlickity(el) {
    if (typeof Flickity === 'undefined' || !el) return null;
    return Flickity.data(el);
  }

  function initCarousel(el) {
    if (!el || typeof Flickity === 'undefined') return null;
    if (el.classList.contains('flickity-enabled')) return getFlickity(el);
    return new Flickity(el, parseFlickityConfig(el));
  }

  function getFeaturedActivePanel(section) {
    return (
      section.querySelector(FEATURED_PANEL + '.is-active') ||
      section.querySelector(FEATURED_PANEL + ':not([hidden])')
    );
  }

  function getFeaturedActiveCarouselEl(section) {
    var panel = getFeaturedActivePanel(section);
    return panel ? panel.querySelector('[data-flickity-config]') : null;
  }

  function getSlideCount(flk) {
    if (!flk) return 0;
    if (flk.slides && flk.slides.length) return flk.slides.length;
    return flk.cells ? flk.cells.length : 0;
  }

  function canGoPrev(flk) {
    if (!flk || !getSlideCount(flk)) return false;
    if (flk.options.wrapAround) return true;
    return flk.selectedIndex > 0;
  }

  function canGoNext(flk) {
    if (!flk || !getSlideCount(flk)) return false;
    if (flk.options.wrapAround) return true;
    return flk.selectedIndex < getSlideCount(flk) - 1;
  }

  function updateFeaturedNav(section) {
    var prevBtns = section.querySelectorAll('[data-sk-carousel-prev]');
    var nextBtns = section.querySelectorAll('[data-sk-carousel-next]');
    if (!prevBtns.length || !nextBtns.length) return;

    var flk = getFlickity(getFeaturedActiveCarouselEl(section));
    var prevDisabled = !canGoPrev(flk);
    var nextDisabled = !canGoNext(flk);

    prevBtns.forEach(function (btn) {
      btn.disabled = prevDisabled;
    });
    nextBtns.forEach(function (btn) {
      btn.disabled = nextDisabled;
    });
  }

  function onFeaturedCarouselSelect(section, el) {
    var flk = getFlickity(el);
    adjustFeaturedTailAlign(el, flk);
    updateFeaturedNav(section);
  }

  function attachFeaturedNavListener(section, el) {
    var flk = getFlickity(el);
    if (!flk || flk._skTabbedNavBound) return;
    flk._skTabbedNavBound = true;
    flk.on('select', function () {
      onFeaturedCarouselSelect(section, el);
    });
    flk.on('settle', function () {
      adjustFeaturedTailAlign(el, flk);
      updateFeaturedNav(section);
    });
  }

  function bindFeaturedNav(section) {
    section.querySelectorAll('[data-sk-carousel-nav]').forEach(function (nav) {
      var prevBtn = nav.querySelector('[data-sk-carousel-prev]');
      var nextBtn = nav.querySelector('[data-sk-carousel-next]');
      if (!prevBtn || !nextBtn || prevBtn.dataset.skFeaturedNavBound === 'true') return;

      prevBtn.dataset.skFeaturedNavBound = 'true';
      nextBtn.dataset.skFeaturedNavBound = 'true';

      prevBtn.addEventListener('click', function () {
        var flk = getFlickity(getFeaturedActiveCarouselEl(section));
        if (flk) flk.previous();
      });

      nextBtn.addEventListener('click', function () {
        var flk = getFlickity(getFeaturedActiveCarouselEl(section));
        if (flk) flk.next();
      });
    });
  }

  function getFeaturedVisibleCols() {
    var w = window.innerWidth;
    if (w >= 1243) return 4;
    if (w >= 1008) return 3;
    return 2;
  }

  function adjustFeaturedTailAlign(el, flk) {
    if (!el || !flk || !flk.cells || !flk.cells.length) return;

    el.classList.remove('is-tail-centered');

    var cols = getFeaturedVisibleCols();
    var remainder = flk.cells.length % cols;
    if (!remainder || !flk.slides || !flk.slides.length) return;
    if (flk.selectedIndex !== flk.slides.length - 1) return;

    var slide = flk.slides[flk.slides.length - 1];
    if (!slide || !slide.cells.length) return;

    el.classList.add('is-tail-centered');

    var viewport = flk.size.innerWidth;
    var groupLeft = slide.cells[0].target;
    var lastCell = slide.cells[slide.cells.length - 1];
    var groupWidth = lastCell.target + lastCell.size.outerWidth - groupLeft;
    var centeredX = -groupLeft + (viewport - groupWidth) / 2;

    flk.x = Math.min(0, centeredX);
    flk.positionSlider();
  }

  function syncFeaturedCarousel(section, el) {
    var flk = getFlickity(el);
    if (!flk) return;

    var groupCells = getFeaturedVisibleCols();
    var needsReload = flk.options.groupCells !== groupCells;

    if (flk.options.contain !== true) {
      flk.options.contain = true;
      needsReload = true;
    }

    if (needsReload) {
      flk.options.groupCells = groupCells;
      flk.reloadCells();
    }

    flk.resize();
    adjustFeaturedTailAlign(el, flk);
    updateFeaturedNav(section);
  }

  function setupFeaturedCarousel(section, el) {
    if (!el) return;
    var panel = el.closest(FEATURED_PANEL);
    if (panel && panel.hidden) return;

    initCarousel(el);
    syncFeaturedCarousel(section, el);
    attachFeaturedNavListener(section, el);
    updateFeaturedNav(section);
  }

  function hydrateDeferredImages(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('img[data-sk-defer-src], img[data-sk-defer-alt]').forEach(function (img) {
      if (img.getAttribute('src') && img.getAttribute('src').indexOf('data:image') !== 0) return;
      var src = img.getAttribute('data-src');
      var srcset = img.getAttribute('data-srcset');
      var sizes = img.getAttribute('data-sizes');
      if (srcset) img.setAttribute('srcset', srcset);
      if (sizes) img.setAttribute('sizes', sizes);
      if (src) img.setAttribute('src', src);
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-sizes');
      img.removeAttribute('data-sk-defer-src');
      img.removeAttribute('data-sk-defer-alt');
    });
  }

  function initProductAlternateImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.ProductItem__ImageWrapper--withAlternateImage').forEach(function (wrapper) {
      if (wrapper.dataset.skAltInit === 'true') return;
      wrapper.dataset.skAltInit = 'true';

      function hydrateAlternate() {
        hydrateDeferredImages(wrapper);
      }

      wrapper.addEventListener('mouseenter', hydrateAlternate, { once: true });
      wrapper.addEventListener('focusin', hydrateAlternate, { once: true });
      wrapper.addEventListener('touchstart', hydrateAlternate, { once: true, passive: true });
    });
  }

  function bindDeferredImagePanels(scope) {
    var root = scope || document;
    root.querySelectorAll('.TabPanel').forEach(function (panel) {
      if (panel.dataset.skDeferObs === 'true') return;
      panel.dataset.skDeferObs = 'true';

      var observer = new MutationObserver(function () {
        var visible = panel.getAttribute('aria-hidden') === 'false' && !panel.hidden;
        if (visible) hydrateDeferredImages(panel);
      });

      observer.observe(panel, { attributes: true, attributeFilter: ['aria-hidden', 'hidden'] });

      if (panel.getAttribute('aria-hidden') === 'false' && !panel.hidden) {
        hydrateDeferredImages(panel);
      }
    });
  }

  function switchFeaturedTab(section, tab) {
    if (tab.classList.contains('is-active')) return;

    var panelId = tab.getAttribute('aria-controls');
    var panel = section.querySelector('#' + panelId);
    if (!panel) return;

    section.querySelectorAll('[data-action="toggle-tab"]').forEach(function (btn) {
      var active = btn === tab;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    section.querySelectorAll(FEATURED_PANEL).forEach(function (p) {
      var show = p === panel;
      p.setAttribute('aria-hidden', show ? 'false' : 'true');
      p.hidden = !show;
      p.classList.toggle('is-active', show);

      if (show) {
        hydrateDeferredImages(p);
        var carouselEl = p.querySelector('[data-flickity-config]');
        window.requestAnimationFrame(function () {
          setupFeaturedCarousel(section, carouselEl);
        });
      }
    });
  }

  function initFeaturedCarousels(scope) {
    var root = scope || document;
    root.querySelectorAll(FLICKITY_SECTION).forEach(function (section) {
      if (section.dataset.skFeaturedInit === 'true') return;
      section.dataset.skFeaturedInit = 'true';

      bindFeaturedNav(section);

      section.querySelectorAll('[data-action="toggle-tab"]').forEach(function (tab) {
        tab.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            switchFeaturedTab(section, tab);
          },
          true
        );
      });

      section.querySelectorAll('[data-flickity-config]').forEach(function (el) {
        attachFeaturedNavListener(section, el);
      });

      window.requestAnimationFrame(function () {
        setupFeaturedCarousel(section, getFeaturedActiveCarouselEl(section));
      });
    });
  }

  function destroyFeaturedCarousels(scope) {
    var root = scope || document;
    if (typeof Flickity === 'undefined') return;

    root.querySelectorAll(FLICKITY_SECTION + ' [data-flickity-config].flickity-enabled').forEach(function (el) {
      var instance = Flickity.data(el);
      if (instance) instance.destroy();
    });
  }

  /* ==========================================================================
     Scroll reveal
     ========================================================================== */

  function initSkReveal(scope) {
    var root = scope || document;
    var elements = root.querySelectorAll('[data-sk-reveal]:not([data-sk-reveal-init])');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
        el.setAttribute('data-sk-reveal-init', 'true');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -32px 0px' }
    );

    elements.forEach(function (el) {
      el.setAttribute('data-sk-reveal-init', 'true');
      observer.observe(el);
    });
  }

  /* ==========================================================================
     Collage — kadraj / odak noktası
     ========================================================================== */

  var COLLAGE_PRODUCT_HANDLES = {
    'mini-fular': true
  };

  var COLLAGE_FOCAL_OVERRIDES = {
    'cotton-fular': 'right center',
    'kadin-gomlek': 'center 12%',
    sapka: 'center 12%',
    scrunchie: 'center 42%'
  };

  var COLLAGE_RESPONSIVE_HANDLES = {
    'sal-pareo': true
  };

  function getCollageCardHandle(card) {
    if (!card || !card.classList) return '';

    for (var i = 0; i < card.classList.length; i++) {
      var part = card.classList[i].slice('SkCollageHero__card--'.length);

      if (!part || part === card.classList[i]) continue;
      if (/^(hero|tall|wide|medium|small|s\d+)$/.test(part)) continue;
      return part;
    }

    return '';
  }

  function fitCollageFocal(img) {
    if (!img.naturalWidth) return;

    var card = img.closest('.SkCollageHero__card');
    if (!card || card.classList.contains('SkCollageHero__card--esarp')) return;

    var handle = getCollageCardHandle(card);

    if (COLLAGE_RESPONSIVE_HANDLES[handle]) {
      img.style.objectPosition = '';
      img.style.transform = '';
      return;
    }

    var box = img.parentElement;
    if (box && box.tagName === 'PICTURE') {
      box = card.querySelector('.SkCollageHero__photo');
    }
    if (!box) return;

    var cw = box.clientWidth;
    var ch = box.clientHeight;
    if (!cw || !ch) return;

    img.style.objectPosition = '';
    img.style.transform = '';

    if (COLLAGE_FOCAL_OVERRIDES[handle]) {
      img.style.objectPosition = COLLAGE_FOCAL_OVERRIDES[handle];
      return;
    }

    if (COLLAGE_PRODUCT_HANDLES[handle]) {
      img.style.objectPosition = 'center center';
      return;
    }

    var imageRatio = img.naturalWidth / img.naturalHeight;
    var boxRatio = cw / ch;

    if (imageRatio < boxRatio * 0.9) {
      img.style.objectPosition = 'center top';
      return;
    }

    if (imageRatio > boxRatio * 1.15) {
      img.style.objectPosition = 'center center';
      return;
    }

    img.style.objectPosition = 'center 22%';
  }

  function initCollageFocalImages(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;

    root
      .querySelectorAll('.SkCollageHero__card:not(.SkCollageHero__card--esarp) .SkCollageHero__photo img')
      .forEach(function (img) {
        function run() {
          fitCollageFocal(img);
        }

        if (img.complete && img.naturalWidth) run();
        else img.addEventListener('load', run, { once: true });
      });
  }

  /* ==========================================================================
     Collage — eşarp: tam görsel, yan boşluk yok
     ========================================================================== */

  function fitEsarpCollageImage(img) {
    if (!img.naturalWidth) return;

    var box = img.parentElement;
    if (!box) return;

    var cw = box.clientWidth;
    var ch = box.clientHeight;
    if (!cw || !ch) return;

    var imageRatio = img.naturalWidth / img.naturalHeight;
    var fitWidthAtFullHeight = ch * imageRatio;

    img.style.transform = '';
    img.style.margin = '';
    img.style.maxWidth = '';
    img.style.maxHeight = '';

    if (fitWidthAtFullHeight >= cw) {
      img.style.width = 'auto';
      img.style.height = '100%';
      img.style.maxWidth = '100%';
      return;
    }

    img.style.width = '100%';
    img.style.height = 'auto';
  }

  function initEsarpCollageImages(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;

    root.querySelectorAll('.SkCollageHero__card--esarp .SkCollageHero__photo img').forEach(function (img) {
      function run() {
        fitEsarpCollageImage(img);
      }

      if (img.complete && img.naturalWidth) run();
      else img.addEventListener('load', run, { once: true });
    });
  }

  /* ==========================================================================
     Background video — clean loop, no YouTube chrome
     ========================================================================== */

  var BACKGROUND_VIDEO_SECTION = '[data-section-type="background-video"]';

  function startYouTubeLoopGuard(player) {
    return window.setInterval(function () {
      try {
        if (!player || typeof player.getCurrentTime !== 'function') return;

        var duration = player.getDuration();
        var currentTime = player.getCurrentTime();
        var playerState = typeof player.getPlayerState === 'function' ? player.getPlayerState() : null;

        if (window.YT && playerState === window.YT.PlayerState.ENDED) {
          player.seekTo(0, true);
          player.playVideo();
          return;
        }

        if (
          playerState === window.YT.PlayerState.PLAYING &&
          duration > 8 &&
          currentTime > 1 &&
          currentTime / duration >= 0.88
        ) {
          player.seekTo(0, true);
          player.playVideo();
        }
      } catch (error) {
        /* noop */
      }
    }, 150);
  }

  function loadYouTubeApi() {
    return new Promise(function (resolve) {
      if (window.YT && window.YT.Player) {
        resolve();
        return;
      }

      var previousReady = window.onYouTubeIframeAPIReady;

      window.onYouTubeIframeAPIReady = function () {
        if (typeof previousReady === 'function') {
          previousReady();
        }

        resolve();
      };

      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.body.appendChild(script);
        return;
      }

      var attempts = 0;
      var poll = window.setInterval(function () {
        attempts += 1;

        if (window.YT && window.YT.Player) {
          window.clearInterval(poll);
          resolve();
        } else if (attempts > 50) {
          window.clearInterval(poll);
          resolve();
        }
      }, 100);
    });
  }

  function getBackgroundVideoPlayer(holder) {
    if (!holder || !holder.id || !window.YT || typeof window.YT.get !== 'function') {
      return null;
    }

    return window.YT.get(holder.id);
  }

  function mountBackgroundVideoPlayer(section, settings, holder) {
    if (!holder || section.dataset.skVideoMounted === 'true') return;

    section.dataset.skVideoMounted = 'true';

    section._skBackgroundPlayer = new window.YT.Player(holder, {
      host: 'https://www.youtube-nocookie.com',
      videoId: settings.videoId,
      playerVars: {
        autoplay: 1,
        mute: 1,
        showinfo: 0,
        controls: 0,
        fs: 0,
        rel: 0,
        iv_load_policy: 3,
        cc_load_policy: 0,
        html5: 1,
        loop: 1,
        playlist: settings.videoId,
        playsinline: 1,
        modestbranding: 1,
        disablekb: 1,
        autohide: 1,
        origin: window.location.origin
      },
      events: {
        onReady: function (event) {
          event.target.mute();
          event.target.playVideo();
          section._skLoopGuardInterval = startYouTubeLoopGuard(event.target);
        },
        onStateChange: function (event) {
          if (event.data === window.YT.PlayerState.ENDED) {
            event.target.seekTo(0, true);
            event.target.playVideo();
          }
        }
      }
    });
  }

  function resetBackgroundVideoPlayer(section, settings, holder) {
    var existingPlayer = getBackgroundVideoPlayer(holder);

    if (existingPlayer && typeof existingPlayer.destroy === 'function') {
      try {
        existingPlayer.destroy();
      } catch (error) {
        /* noop */
      }
    }

    holder.innerHTML = '';
    delete section.dataset.skVideoMounted;

    if (section._skLoopGuardInterval) {
      window.clearInterval(section._skLoopGuardInterval);
      section._skLoopGuardInterval = null;
    }

    mountBackgroundVideoPlayer(section, settings, holder);
  }

  function initBackgroundVideoGuard(section) {
    if (!section || section.dataset.skVideoGuardInit === 'true') return;

    var settings;

    try {
      settings = JSON.parse(section.getAttribute('data-section-settings'));
    } catch (error) {
      return;
    }

    if (!settings || settings.videoType !== 'youtube') return;

    var holder = section.querySelector('.ImageHero__VideoHolder');
    if (!holder) return;

    function startGuard() {
      if (section.dataset.skVideoGuardInit === 'true') return;

      loadYouTubeApi().then(function () {
        if (section.dataset.skVideoGuardInit === 'true') return;

        var attempts = 0;
        var poll = window.setInterval(function () {
          attempts += 1;
          var player = getBackgroundVideoPlayer(holder);

          if (player && typeof player.getCurrentTime === 'function') {
            window.clearInterval(poll);
            section.dataset.skVideoGuardInit = 'true';
            section._skLoopGuardInterval = startYouTubeLoopGuard(player);

            window.setTimeout(function () {
              var state = typeof player.getPlayerState === 'function' ? player.getPlayerState() : null;

              if (
                state === window.YT.PlayerState.UNSTARTED ||
                state === window.YT.PlayerState.CUED ||
                state === window.YT.PlayerState.ENDED
              ) {
                resetBackgroundVideoPlayer(section, settings, holder);
              }
            }, 4000);

            return;
          }

          if (attempts >= 24) {
            window.clearInterval(poll);
            section.dataset.skVideoGuardInit = 'true';
            mountBackgroundVideoPlayer(section, settings, holder);
          }
        }, 250);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          startGuard();
        });
      }, { rootMargin: '200px 0px', threshold: 0.01 });

      observer.observe(section);
    } else {
      startGuard();
    }
  }

  function destroyBackgroundVideoGuard(section) {
    if (section._skLoopGuardInterval) {
      window.clearInterval(section._skLoopGuardInterval);
      section._skLoopGuardInterval = null;
    }

    if (section._skBackgroundPlayer && typeof section._skBackgroundPlayer.destroy === 'function') {
      try {
        section._skBackgroundPlayer.destroy();
      } catch (error) {
        /* noop */
      }
    }

    delete section._skBackgroundPlayer;
    delete section.dataset.skVideoGuardInit;
    delete section.dataset.skVideoMounted;
  }

  function initBackgroundVideoGuards(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;

    root.querySelectorAll(BACKGROUND_VIDEO_SECTION).forEach(initBackgroundVideoGuard);
  }

  /* ==========================================================================
     YouTube iframes — native loading="lazy" for below-fold embeds
     ========================================================================== */

  function initSkYoutubeIframeLazy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="youtube-nocookie"]').forEach(function (iframe) {
      if (iframe.hasAttribute('loading')) return;
      if (iframe.closest('[data-section-type="background-video"]')) return;
      iframe.setAttribute('loading', 'lazy');
    });
  }

  /* ==========================================================================
     mega menu — crossfading hero image on link hover
     ========================================================================== */

  var SK_MEGA_MENU = '[data-sk-mega-menu]';
  var skMegaPreloadCache = {};

  function preloadSkImage(src) {
    if (!src || skMegaPreloadCache[src]) return;
    var img = new Image();
    img.src = src;
    skMegaPreloadCache[src] = img;
  }

  function setSkHeroImage(state, nextSrc, nextLabel) {
    if (!nextSrc) return;

    var labelEl = state.labelEl;
    if (labelEl && typeof nextLabel === 'string' && labelEl.textContent !== nextLabel) {
      labelEl.classList.add('is-swapping');
      window.setTimeout(function () {
        labelEl.textContent = nextLabel;
        labelEl.classList.remove('is-swapping');
      }, 180);
    }

    if (state.currentSrc === nextSrc) return;
    state.currentSrc = nextSrc;

    var activeLayer = state.layers[state.activeIndex];
    var nextIndex = state.activeIndex === 0 ? 1 : 0;
    var nextLayer = state.layers[nextIndex];

    var commit = function () {
      // Only commit if this is still the most recent request
      if (state.currentSrc !== nextSrc) return;
      nextLayer.classList.add('is-active');
      activeLayer.classList.remove('is-active');
      state.activeIndex = nextIndex;
    };

    var loader = new Image();
    loader.onload = commit;
    loader.onerror = commit;
    loader.src = nextSrc;
    nextLayer.src = nextSrc;

    if (loader.complete) commit();
  }

  function clearSkNavActive(menu) {
    menu.querySelectorAll('.MegaMenu__NavFlatLink.is-active, [data-sk-menu-link].is-active').forEach(function (link) {
      link.classList.remove('is-active');
    });
  }

  function resetSkHero(menu, state) {
    if (state) {
      var defaultSrc = menu.getAttribute('data-sk-default-image');
      var defaultLabel = menu.getAttribute('data-sk-default-label') || '';
      setSkHeroImage(state, defaultSrc, defaultLabel);
    }
    clearSkNavActive(menu);
  }

  function initSkMegaMenu(root) {
    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll(SK_MEGA_MENU).forEach(function (menu) {
      if (menu.dataset.skMegaInit === 'true') return;
      menu.dataset.skMegaInit = 'true';

      var layers = menu.querySelectorAll('[data-sk-hero-layer]');
      var navRoot = menu.querySelector('[data-sk-mega-columns]');
      var navLinks = navRoot
        ? navRoot.querySelectorAll('.MegaMenu__NavFlatLink, [data-sk-menu-link]')
        : [];

      // Defer image preloading until menu is first activated
      var skMegaPreloaded = false;
      function preloadSkMenuImages() {
        if (skMegaPreloaded) return;
        skMegaPreloaded = true;
        menu.querySelectorAll('[data-sk-menu-link]').forEach(function (link) {
          preloadSkImage(link.getAttribute('data-sk-menu-image'));
        });
        preloadSkImage(menu.getAttribute('data-sk-default-image'));
      }
      menu.addEventListener('mouseenter', preloadSkMenuImages, { once: true });

      var state = null;
      if (layers.length >= 2) {
        state = {
          layers: layers,
          activeIndex: 0,
          currentSrc: menu.getAttribute('data-sk-default-image') || '',
          labelEl: menu.querySelector('[data-sk-hero-label]')
        };
      }

      navLinks.forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          clearSkNavActive(menu);
          link.classList.add('is-active');

          if (!state) return;
          var src = link.getAttribute('data-sk-menu-image');
          if (src) {
            setSkHeroImage(state, src, link.getAttribute('data-sk-menu-label') || '');
          }
        });
      });

      if (navRoot) {
        navRoot.addEventListener('mouseleave', function () {
          resetSkHero(menu, state);
        });
      }

      menu.addEventListener('mouseleave', function () {
        resetSkHero(menu, state);
      });
    });
  }

  function initSkMegaMenuNavGuard(root) {
    var scope = root && root.querySelector ? root : document;
    var header = scope.matches && scope.matches('.shopify-section--header')
      ? scope
      : scope.querySelector('.shopify-section--header');

    if (!header || header.dataset.skMegaNavGuard === 'true') return;
    header.dataset.skMegaNavGuard = 'true';

    function hideOtherSkMegaMenus(activeMenu) {
      header.querySelectorAll(SK_MEGA_MENU).forEach(function (menu) {
        if (menu === activeMenu) return;
        menu.setAttribute('aria-hidden', 'true');
        var item = menu.closest('.HorizontalList__Item');
        if (item) item.classList.remove('is-expanded');
      });
    }

    function hydrateMegaMenuImages(menu) {
      menu.querySelectorAll('img[data-src]').forEach(function (img) {
        if (!img.src || img.src === '' || img.src === window.location.href) {
          img.src = img.dataset.src;
        }
      });
    }

    function activateSkMegaMenu(menu) {
      if (!menu) return;
      hideOtherSkMegaMenus(menu);
      hydrateMegaMenuImages(menu);
      menu.setAttribute('aria-hidden', 'false');
      var item = menu.closest('.HorizontalList__Item');
      if (item) {
        header.querySelectorAll('.Header__MainNav .HorizontalList__Item.is-expanded').forEach(function (li) {
          if (li !== item) li.classList.remove('is-expanded');
        });
        item.classList.add('is-expanded');
      }
    }

    header.addEventListener('mouseenter', function (event) {
      var item = event.target.closest('.Header__MainNav .HorizontalList__Item');
      if (!item) return;
      var activeMenu = item.querySelector(SK_MEGA_MENU);
      if (!activeMenu) return;
      activateSkMegaMenu(activeMenu);
    }, true);

    header.querySelectorAll(SK_MEGA_MENU).forEach(function (menu) {
      menu.addEventListener('mouseenter', function () {
        activateSkMegaMenu(menu);
      });
    });
  }

  /* ==========================================================================
     Header — responsive breakpoint sync (1243px desktop nav)
     ========================================================================== */

  var SK_HEADER_DESK_MQ = window.matchMedia('screen and (min-width: 1243px)');
  var skHeaderWasDesk = null;

  function isSkHeaderDesk() {
    return SK_HEADER_DESK_MQ.matches;
  }

  function closeSkSidebarDrawer() {
    var drawer = document.getElementById('sidebar-menu');
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;

    var closeBtn = drawer.querySelector('[data-action="close-drawer"]');
    if (closeBtn) {
      closeBtn.click();
      return;
    }

    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');

    var overlay = document.querySelector('.PageOverlay');
    if (overlay) overlay.classList.remove('is-visible');
  }

  function resetSkHeaderNavigationState(headerSection) {
    if (!headerSection) return;

    headerSection.querySelectorAll('.is-expanded').forEach(function (item) {
      item.classList.remove('is-expanded');
    });

    headerSection.querySelectorAll('.DropdownMenu, ' + SK_MEGA_MENU).forEach(function (menu) {
      menu.setAttribute('aria-hidden', 'true');
    });

    headerSection.querySelectorAll(SK_MEGA_MENU).forEach(function (menu) {
      menu.querySelectorAll('.is-active').forEach(function (link) {
        link.classList.remove('is-active');
      });
    });
  }

  function updateSkHeaderLayout(headerEl) {
    if (!headerEl || !isSkHeaderDesk()) return;

    var mainNav = headerEl.querySelector('.Header__MainNav');
    if (!mainNav) return;

    if (window.getComputedStyle(mainNav).display === 'none') return;

    var navStyle = 'logoLeft';
    try {
      var settings = JSON.parse(headerEl.getAttribute('data-section-settings') || '{}');
      if (settings.navigationStyle) navStyle = settings.navigationStyle;
    } catch (e) {
      /* noop */
    }

    headerEl.classList.remove('Header--center');
    headerEl.classList.add('Header--' + navStyle);
    headerEl.classList.add('Header--initialized');
    headerEl.classList.add('Header--skSingleRow');

    var headerSection = document.getElementById('shopify-section-header');
    var heightSource = headerSection || headerEl;
    document.documentElement.style.setProperty('--header-height', heightSource.offsetHeight + 'px');
  }

  function watchSkHeaderSingleRowLayout() {
    var headerEl = document.querySelector('#shopify-section-header .Header, .shopify-section--header .Header');
    if (!headerEl || headerEl.dataset.skHeaderLayoutWatch === 'true') return;
    headerEl.dataset.skHeaderLayoutWatch = 'true';
    headerEl.classList.add('Header--skSingleRow');

    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (!isSkHeaderDesk()) return;
      if (headerEl.classList.contains('Header--center')) {
        updateSkHeaderLayout(headerEl);
      }
    });

    observer.observe(headerEl, { attributes: true, attributeFilter: ['class'] });
  }

  function scheduleSkHeaderLayoutUpdate() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var headerEl = document.querySelector('#shopify-section-header .Header, .shopify-section--header .Header');
        updateSkHeaderLayout(headerEl);
      });
    });
  }

  function syncSkHeaderResponsiveState() {
    var isDesk = isSkHeaderDesk();

    if (skHeaderWasDesk === null) {
      skHeaderWasDesk = isDesk;
      if (isDesk) scheduleSkHeaderLayoutUpdate();
      return;
    }

    if (isDesk === skHeaderWasDesk) {
      if (isDesk) scheduleSkHeaderLayoutUpdate();
      return;
    }

    var headerSection = document.getElementById('shopify-section-header');

    if (isDesk) {
      closeSkSidebarDrawer();
      resetSkHeaderNavigationState(headerSection);
      scheduleSkHeaderLayoutUpdate();
    } else {
      resetSkHeaderNavigationState(headerSection);
    }

    skHeaderWasDesk = isDesk;
  }

  /* ==========================================================================
     Prevent redundant same-page navigation
     ========================================================================== */

  function normalizeSkPathname(pathname) {
    if (!pathname) return '/';
    if (pathname.length > 1 && pathname.endsWith('/')) {
      return pathname.replace(/\/+$/, '') || '/';
    }
    return pathname;
  }

  function shouldSkipRedundantLinkGuard(link, event) {
    if (!link || !event) return true;
    if (event.defaultPrevented) return true;
    if (event.button !== 0) return true;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return true;
    if (link.target && link.target !== '_self') return true;
    if (link.hasAttribute('download')) return true;
    if (link.getAttribute('rel') === 'external') return true;
    if (link.hasAttribute('data-allow-same-page-nav')) return true;
    return false;
  }

  function isRedundantSamePageNavigation(link) {
    var href = link.getAttribute('href');
    if (!href || href.indexOf('javascript:') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) {
      return false;
    }

    var nextUrl;
    try {
      nextUrl = new URL(link.href, window.location.origin);
    } catch (e) {
      return false;
    }

    var current = window.location;
    if (nextUrl.origin !== current.origin) return false;
    if (normalizeSkPathname(nextUrl.pathname) !== normalizeSkPathname(current.pathname)) return false;
    if (nextUrl.search !== current.search) return false;

    // Allow normal in-page anchor navigation if hash actually changes.
    if (nextUrl.hash && nextUrl.hash !== current.hash) return false;

    return true;
  }

  function trimRecentlyViewedProducts() {
    try {
      var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
      var trimmed = items.slice(0, 3);
      if (trimmed.length !== items.length) {
        localStorage.setItem('recentlyViewedProducts', JSON.stringify(trimmed));
      }
    } catch (error) {
      /* ignore */
    }
  }

  function showSkCartToast(message) {
    var existing = document.querySelector('.SkCartToast');
    if (existing) {
      existing.remove();
    }

    var toast = document.createElement('div');
    toast.className = 'SkCartToast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    document.body.appendChild(toast);

    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        toast.remove();
      }, 300);
    }, 2400);
  }

  var SK_COLLECTION_FILTER_MQ = window.matchMedia('(max-width: 1498px)');
  var SK_COLLECTION_FILTER_POCKET_MQ = window.matchMedia('(max-width: 1007px)');

  function initSkCollectionFilterPopover(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-sk-collection-filter-popover]').forEach(function (popover) {
      if (popover.dataset.skFilterPopoverInit === 'true') {
        return;
      }

      var activator = document.querySelector('[aria-controls="' + popover.id + '"]');
      if (!activator) {
        return;
      }

      popover.dataset.skFilterPopoverInit = 'true';

      // Move the popover to <body>: it is rendered inside the sticky toolbar
      // strip (z-index: 4), whose stacking context would trap it below the
      // page overlay (z-index: 10), making the options look disabled and
      // swallowing clicks on mobile/tablet.
      if (popover.parentElement !== document.body) {
        document.body.appendChild(popover);
      }

      var overlay = document.querySelector('.PageOverlay');
      var isOpen = false;

      // Dropdown is active either below the 1498px breakpoint, or when the
      // collection forces it (6+ filters) via SkCollectionBar--forceDropdown.
      function isFilterDropdownActive() {
        if (SK_COLLECTION_FILTER_MQ.matches) {
          return true;
        }
        var bar = activator.closest('.SkCollectionBar');
        return !!(bar && bar.classList.contains('SkCollectionBar--forceDropdown'));
      }

      function closePopover() {
        if (!isOpen) {
          return;
        }

        isOpen = false;
        popover.setAttribute('aria-hidden', 'true');
        activator.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('no-scroll');

        if (overlay && SK_COLLECTION_FILTER_POCKET_MQ.matches) {
          overlay.classList.remove('is-visible');
          overlay.removeEventListener('click', closePopover);
        }

        if (!SK_COLLECTION_FILTER_POCKET_MQ.matches) {
          document.body.removeEventListener('click', onOutsideClick);
          popover.removeAttribute('style');
        }
      }

      function onOutsideClick(event) {
        if (
          !popover.contains(event.target) &&
          event.target !== activator &&
          !activator.contains(event.target)
        ) {
          closePopover();
        }
      }

      function positionPopover() {
        if (SK_COLLECTION_FILTER_POCKET_MQ.matches) {
          return;
        }

        var rect = activator.getBoundingClientRect();
        popover.classList.remove('Popover--alignBottom', 'Popover--alignCenter');
        popover.classList.add('Popover--positionBottom', 'Popover--alignTop');
        popover.setAttribute(
          'style',
          'top: ' +
            (rect.bottom + 8) +
            'px; left: ' +
            rect.left +
            'px; right: auto; min-width: ' +
            rect.width +
            'px;'
        );
      }

      function openPopover() {
        if (!isFilterDropdownActive() || isOpen) {
          return;
        }

        isOpen = true;
        popover.setAttribute('aria-hidden', 'false');
        activator.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('no-scroll');

        if (overlay && SK_COLLECTION_FILTER_POCKET_MQ.matches) {
          overlay.classList.add('is-visible');
          overlay.addEventListener('click', closePopover);
        } else {
          positionPopover();
          document.body.addEventListener('click', onOutsideClick);
        }
      }

      function togglePopover(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!isFilterDropdownActive()) {
          return;
        }

        if (isOpen) {
          closePopover();
        } else {
          openPopover();
        }
      }

      activator.addEventListener('click', togglePopover);

      popover.querySelectorAll('[data-action="close-popover"]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          closePopover();
        });
      });

      popover.querySelectorAll('.Popover__Value[href]').forEach(function (link) {
        link.addEventListener('click', closePopover);
      });

      window.addEventListener('resize', function () {
        if (!isFilterDropdownActive()) {
          closePopover();
        } else if (isOpen && !SK_COLLECTION_FILTER_POCKET_MQ.matches) {
          positionPopover();
        }
      });
    });
  }

  function initSkCollectionAddToCart() {
    if (document.documentElement.dataset.skCollectionCartInit === 'true') {
      return;
    }

    document.documentElement.dataset.skCollectionCartInit = 'true';

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sk-add-to-cart]');
      if (!button || button.disabled || button.classList.contains('is-loading')) {
        return;
      }

      var grid = button.closest('.SkCollection__grid, .ProductList--grid');
      if (!grid) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
      if (!variantId) {
        return;
      }

      var cartDrawer = document.getElementById('sidebar-cart');
      button.classList.add('is-loading');
      button.disabled = true;
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify({ id: variantId, quantity: 1 }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          if (!response.ok) {
            return response.json().then(function (content) {
              throw new Error(content && content.description ? content.description : 'Add to cart failed');
            });
          }

          return response.json();
        })
        .then(function () {
          showSkCartToast(
            (window.languages && window.languages.productAddedToCart) || 'Product added to cart'
          );

          document.dispatchEvent(
            new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: { id: variantId },
                quantity: 1
              }
            })
          );
        })
        .catch(function (error) {
          if (!cartDrawer) {
            window.location.href = window.routes.cartUrl;
            return;
          }

          showSkCartToast(
            error.message || ((window.languages && window.languages.addToCartFailed) || 'Could not add to cart')
          );
        })
        .finally(function () {
          button.classList.remove('is-loading');
          if (!button.hasAttribute('data-sk-sold-out')) {
            button.disabled = false;
          }
        });
    });
  }

  function initRedundantNavigationGuard() {
    if (document.documentElement.dataset.skRedundantNavGuard === 'true') return;
    document.documentElement.dataset.skRedundantNavGuard = 'true';

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest ? event.target.closest('a[href]') : null;
        if (shouldSkipRedundantLinkGuard(link, event)) return;
        if (!isRedundantSamePageNavigation(link)) return;

        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  /* ==========================================================================
     İletişim — tel / adres linkleri
     ========================================================================== */

  function initSkContactPage(scope) {
    var section = (scope || document).querySelector('#shopify-section-page-contact-template');
    if (!section || section.dataset.skContactLinksInit) return;

    section.querySelectorAll('.Rte p').forEach(function (p) {
      if (p.closest('form')) return;

      var text = p.textContent || '';
      if (text.indexOf('Adres') === -1 && text.indexOf('Tel') === -1 && text.indexOf('Address') === -1 && text.indexOf('Phone') === -1) return;

      var html = p.innerHTML;

      if (html.indexOf('href="tel:') === -1) {
        html = html.replace(/(\+90[\d\s().-]{10,18})/g, function (match, _phone, offset, whole) {
          var before = whole.slice(0, offset);
          if (before.lastIndexOf('<a') > before.lastIndexOf('</a>')) return match;
          return '<a href="tel:' + match.replace(/\D/g, '') + '">' + match.trim() + '</a>';
        });
      }

      if (html.indexOf('google.com/maps') === -1) {
        html = html.replace(
          /((?:<strong>\s*)?(?:Adres|Address):\s*(?:<\/strong>)?)([\s\S]*?)(\s*(?:<br\s*\/?>\s*|<strong>\s*(?:Tel|Phone):))/i,
          function (_, label, middle, end) {
            var plain = middle.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
            if (!plain) return label + middle + end;
            return label + '<a href="https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(plain) + '" target="_blank" rel="noopener noreferrer">' + middle + '</a>' + end;
          }
        );
      }

      if (html !== p.innerHTML) {
        p.innerHTML = html;
        section.dataset.skContactLinksInit = 'true';
      }
    });
  }

  /* ==========================================================================
     Satış Noktaları — region nav scroll spy
     ========================================================================== */

  function initSkStoresPage(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var stores = root.querySelector ? root.querySelector('[data-section-type="stores"]') : null;
    if (!stores) return;

    if (stores.dataset.skStoresInit !== 'true') {
      stores.dataset.skStoresInit = 'true';

      var toolbar = stores.querySelector('[data-sk-stores-toolbar]');

      function getStoresAnchorOffset() {
        var offset = 8;
        var headerSection = document.getElementById('shopify-section-header');

        if (headerSection) {
          offset += headerSection.offsetHeight;
        } else {
          var headerHeight = parseInt(
            getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
            10
          );
          if (!Number.isNaN(headerHeight)) offset += headerHeight;
        }

        if (toolbar) {
          var toolbarStyle = window.getComputedStyle(toolbar);
          if (toolbarStyle.position === 'sticky' || toolbarStyle.position === 'fixed') {
            offset += toolbar.offsetHeight;
          }
        }

        stores.style.setProperty('--sk-stores-scroll-offset', offset + 'px');
        return offset;
      }

      function updateStoresToolbarLayout() {
        if (!toolbar) return;
        stores.style.setProperty('--sk-stores-toolbar-height', toolbar.offsetHeight + 'px');
        getStoresAnchorOffset();
      }

      updateStoresToolbarLayout();
      window.addEventListener('resize', updateStoresToolbarLayout, { passive: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updateStoresToolbarLayout);
      }

      function alignStoreRegionHead(headEl, behavior) {
        if (!headEl) return;

        var offset = getStoresAnchorOffset();
        var scrollBehavior = behavior || 'smooth';
        var targetTop = headEl.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: Math.max(0, targetTop),
          behavior: scrollBehavior
        });

        function snapExact() {
          var drift = headEl.getBoundingClientRect().top - offset;
          if (Math.abs(drift) > 2) {
            window.scrollBy({ top: drift, behavior: 'auto' });
          }
        }

        if (scrollBehavior === 'auto') {
          window.requestAnimationFrame(snapExact);
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(snapExact);
          });
        } else {
          window.setTimeout(function () {
            snapExact();
            window.requestAnimationFrame(snapExact);
          }, 480);
        }
      }

      function scrollToStoreRegionHead(headEl, behavior) {
        alignStoreRegionHead(headEl, behavior);
      }

      function getStoreRegionHeadFromLink(link) {
        var href = link.getAttribute('href');
        if (href && href.charAt(0) === '#') {
          var headEl = document.getElementById(href.slice(1));
          if (headEl) return headEl;
        }

        var regionId = link.getAttribute('data-region-id');
        if (!regionId) return null;
        var region = document.getElementById(regionId);
        return region ? region.querySelector('.SkStores__regionHead') : null;
      }

      var navLinks = stores.querySelectorAll('[data-sk-store-nav]');
      var regions = stores.querySelectorAll('[data-sk-store-region]');

      function setActiveRegion(regionId) {
        navLinks.forEach(function (link) {
          var isActive = link.getAttribute('data-region-id') === regionId;
          link.classList.toggle('is-active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }

      function scrollToStoreRegion(regionId, behavior) {
        var region = document.getElementById(regionId);
        if (!region) return;
        scrollToStoreRegionHead(region.querySelector('.SkStores__regionHead'), behavior);
      }

      navLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
          var headEl = getStoreRegionHeadFromLink(link);
          if (!headEl) return;
          event.preventDefault();
          alignStoreRegionHead(headEl);
          var regionSection = headEl.closest('[data-sk-store-region]');
          if (regionSection) setActiveRegion(regionSection.id);
          if (link.hash) {
            history.replaceState(null, '', link.hash);
          }
        });
      });

      if (window.location.hash.indexOf('store-region') !== -1) {
        var hashTarget = document.getElementById(window.location.hash.slice(1));
        if (hashTarget) {
          var hashHead = hashTarget.matches('.SkStores__regionHead')
            ? hashTarget
            : hashTarget.querySelector
              ? hashTarget.querySelector('.SkStores__regionHead')
              : null;
          var hashRegion = hashTarget.matches('[data-sk-store-region]')
            ? hashTarget
            : hashTarget.closest('[data-sk-store-region]');

          if (hashHead) {
            window.setTimeout(function () {
              scrollToStoreRegionHead(hashHead, 'auto');
              if (hashRegion) setActiveRegion(hashRegion.id);
            }, 0);
          } else if (hashRegion) {
            window.setTimeout(function () {
              scrollToStoreRegion(hashRegion.id, 'auto');
              setActiveRegion(hashRegion.id);
            }, 0);
          }
        }
      }

      if (navLinks.length && regions.length) {
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) setActiveRegion(entry.target.id);
              });
            },
            { rootMargin: '-38% 0px -52% 0px', threshold: 0 }
          );
          regions.forEach(function (region) {
            observer.observe(region);
          });
        } else {
          setActiveRegion(regions[0].id);
        }
      }
    }

    var searchInput = stores.querySelector('[data-sk-store-search]');
    if (!searchInput || searchInput.dataset.skStoresSearchInit === 'true') return;
    searchInput.dataset.skStoresSearchInit = 'true';

    var cards = stores.querySelectorAll('[data-sk-store-card]');
    var regionSections = stores.querySelectorAll('[data-sk-store-region]');
    var emptyState = stores.querySelector('[data-sk-store-empty]');

    function normalizeSearchText(value) {
      return (value || '')
        .toLocaleLowerCase('tr-TR')
        .replace(/ı/g, 'i')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c')
        .trim();
    }

    function filterStores(query) {
      var needle = normalizeSearchText(query);
      var visibleCount = 0;

      cards.forEach(function (card) {
        var haystack = normalizeSearchText(card.getAttribute('data-sk-store-search-text'));
        var match = !needle || haystack.indexOf(needle) !== -1;
        card.classList.toggle('is-filtered-out', !match);
        if (match) visibleCount += 1;
      });

      regionSections.forEach(function (region) {
        var visibleCards = region.querySelectorAll('[data-sk-store-card]:not(.is-filtered-out)');
        region.classList.toggle('is-filtered-out', visibleCards.length === 0);
      });

      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }
    }

    searchInput.addEventListener('input', function () {
      filterStores(searchInput.value);
    });

    if (window.matchMedia('(max-width: 1007px)').matches) {
      stores.querySelectorAll('[data-sk-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
        el.setAttribute('data-sk-reveal-init', 'true');
      });
    } else {
      initSkReveal(stores);
    }
  }

  /* ==========================================================================
     Hakkımızda — mevcut içeriği editorial layout'a dönüştür
     ========================================================================== */

  function paragraphIsImageOnly(paragraph) {
    var clone = paragraph.cloneNode(true);
    clone.querySelectorAll('img, span, br').forEach(function (el) {
      el.remove();
    });
    return !clone.textContent.trim();
  }

  function getSkAboutMobile() {
    return window.matchMedia('(max-width: 1007px)').matches;
  }

  function stripSkAboutParagraphLayoutStyles(block) {
    if (!block || !block.getAttribute('style')) return;
    block.style.removeProperty('width');
    block.style.removeProperty('max-width');
    block.style.removeProperty('min-width');
    if (/text-align\s*:\s*justify/i.test(block.getAttribute('style'))) {
      block.style.textAlign = 'left';
    }
  }

  function fixSkAboutParagraphWidows(block) {
    if (!block || block.querySelector('img')) return;

    var textNodes = [];
    var walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.replace(/\s+/g, '').length) {
        textNodes.push(node);
      }
    }
    if (!textNodes.length) return;

    var lastNode = textNodes[textNodes.length - 1];
    var lastText = lastNode.textContent;
    var words = lastText.trim().split(/\s+/);

    if (words.length >= 2) {
      var bound = words.slice(-2).join('\u00A0');
      var prefix = words.slice(0, -2).join(' ');
      var leading = lastText.match(/^\s*/)[0];
      var trailing = lastText.match(/\s*$/)[0];
      lastNode.textContent = leading + (prefix ? prefix + ' ' : '') + bound + trailing;
      return;
    }

    if (words.length === 1 && textNodes.length > 1) {
      var prevNode = textNodes[textNodes.length - 2];
      var prevText = prevNode.textContent;
      var match = prevText.match(/^(.*?)(\s+)(\S+)\s*$/);
      if (!match) return;
      prevNode.textContent = match[1] + match[2];
      lastNode.textContent = match[3] + '\u00A0' + lastText.trimStart();
    }
  }

  function fixSkAboutMobileTypography(content) {
    if (!content || !getSkAboutMobile()) return;

    content.querySelectorAll('p, li').forEach(function (block) {
      if (
        block.classList.contains('is-lead') ||
        block.classList.contains('is-moved-to-hero') ||
        block.classList.contains('SkAboutPage__timelineLabel')
      ) {
        return;
      }

      block.querySelectorAll('br').forEach(function (br) {
        br.replaceWith(document.createTextNode(' '));
      });

      stripSkAboutParagraphLayoutStyles(block);
      fixSkAboutParagraphWidows(block);
    });
  }


  function initSkAboutHeroScroll(about) {
    var scrollEl = about.querySelector('[data-sk-about-hero-scroll]');
    var heroEl = about.querySelector('[data-sk-about-hero]');
    if (!scrollEl || !heroEl || heroEl.dataset.skAboutHeroInit === 'true') return;

    heroEl.dataset.skAboutHeroInit = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      heroEl.style.setProperty('--sk-about-hero-progress', '0');
      return;
    }

    var ticking = false;

    function updateAboutHeroScroll() {
      ticking = false;
      var rect = scrollEl.getBoundingClientRect();
      var scrollRange = Math.max(scrollEl.offsetHeight - window.innerHeight, 1);
      var scrolled = Math.min(Math.max(-rect.top, 0), scrollRange);
      var progress = Math.min(1, Math.max(0, scrolled / scrollRange));
      progress = progress * progress * (3 - 2 * progress);
      heroEl.style.setProperty('--sk-about-hero-progress', progress.toFixed(4));
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateAboutHeroScroll);
      },
      { passive: true }
    );

    window.addEventListener('resize', updateAboutHeroScroll, { passive: true });
    updateAboutHeroScroll();
  }

  function initSkAboutPage(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var about = root.querySelector ? root.querySelector('[data-section-type="about-page"]') : null;
    if (!about) return;

    if (about.dataset.skAboutInit !== 'true') {
      about.dataset.skAboutInit = 'true';

      var content = about.querySelector('[data-sk-about-content]');

      if (content) {
        content.querySelectorAll('p').forEach(function (paragraph) {
          if (!paragraphIsImageOnly(paragraph)) return;
          var img = paragraph.querySelector('img');
          if (!img) return;
          var figure = document.createElement('figure');
          figure.className = 'SkAboutPage__figure';
          figure.appendChild(img);
          paragraph.replaceWith(figure);
        });

        content.querySelectorAll('ul').forEach(function (list) {
          if (list.closest('.SkAboutPage__timeline')) return;

          var timeline = document.createElement('div');
          timeline.className = 'SkAboutPage__timeline';

          var labelText = (window.languages && window.languages.featuredLabel) || 'Featured';
          var prev = list.previousElementSibling;
          if (prev && prev.tagName === 'P') {
            var prevText = prev.textContent.trim();
            if (prevText && prevText.length < 80) {
              labelText = prevText.replace(/[,，]\s*$/, '');
              prev.remove();
            }
          }

          var label = document.createElement('p');
          label.className = 'SkAboutPage__timelineLabel';
          label.textContent = labelText;

          list.classList.add('SkAboutPage__timelineList');
          list.parentNode.insertBefore(timeline, list);
          timeline.appendChild(label);
          timeline.appendChild(list);
        });

        content.querySelectorAll('blockquote').forEach(function (quote) {
          quote.classList.add('SkAboutPage__pullquote');
        });

        content.querySelectorAll('p').forEach(function (paragraph) {
          var style = paragraph.getAttribute('style') || '';
          var text = paragraph.textContent.trim();

          if (
            (style.indexOf('text-align: right') !== -1 || style.indexOf('text-align:right') !== -1) &&
            text.length < 40
          ) {
            paragraph.classList.add('is-signature');
            return;
          }

          if (
            paragraph.classList.contains('is-signature')
          ) {
            return;
          }

          var emOnly = paragraph.querySelector('em, i');
          if (
            emOnly &&
            text.length > 20 &&
            text.length < 220 &&
            paragraph.children.length === 1
          ) {
            paragraph.classList.add('SkAboutPage__pullquote');
          }
        });

        var firstVisibleParagraph = content.querySelector(
          'p:not(.is-signature):not(.SkAboutPage__pullquote)'
        );
        if (firstVisibleParagraph) {
          firstVisibleParagraph.classList.add('is-lead');
        }

        content.querySelectorAll('.SkAboutPage__figure').forEach(function (figure, index) {
          figure.classList.add(index % 2 === 0 ? 'SkAboutPage__figure--wide' : 'SkAboutPage__figure--offset');
        });
      }
    }

    var aboutContent = about.querySelector('[data-sk-about-content]');
    if (aboutContent) {
      fixSkAboutMobileTypography(aboutContent);
    }

    initSkAboutHeroScroll(about);
    initSkReveal(about);
  }

  /* ==========================================================================
     Book stack — scroll layering with gentle scale on covered cards
     ========================================================================== */

  var SK_BOOK_STACK = '[data-sk-book-stack]';

  function initSkBookStack(scope) {
    var root = scope || document;
    var stacks = root.querySelectorAll(SK_BOOK_STACK + ':not([data-sk-book-stack-init])');
    if (!stacks.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    stacks.forEach(function (stack) {
      stack.setAttribute('data-sk-book-stack-init', 'true');
      var cards = stack.querySelectorAll('.SkBookStack__card');
      var nav = stack.querySelector('[data-sk-book-stack-nav]');
      var navItems = stack.querySelectorAll('[data-sk-book-nav]');
      var lastCard = stack.querySelector('.SkBookStack__card--last');

      function measureBookStackNav() {
        if (!nav) return 0;
        var navHeight = nav.offsetHeight;
        if (navHeight > 0) {
          stack.style.setProperty('--sk-book-stack-nav-height', navHeight + 'px');
        }
        return navHeight;
      }

      measureBookStackNav();

      stack.querySelectorAll('[data-sk-book-stack-video]').forEach(function (video) {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');

        function tryPlayBookStackVideo() {
          if (!video.paused && !video.ended) return;
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }

        video.addEventListener('loadeddata', tryPlayBookStackVideo);
        video.addEventListener('canplay', tryPlayBookStackVideo);
        tryPlayBookStackVideo();
      });

      function updateBookStackNav() {
        if (!nav) return;

        var stackRect = stack.getBoundingClientRect();
        var navHeight = nav.offsetHeight || measureBookStackNav();
        var stackVisible = stackRect.bottom > 0 && stackRect.top < window.innerHeight;

        if (!stackVisible) {
          nav.classList.add('is-hidden');
          nav.classList.remove('is-floating', 'is-docked');
          return;
        }

        nav.classList.remove('is-hidden');

        var dock = stackRect.bottom <= window.innerHeight + 2;

        if (lastCard) {
          var lastSpread = lastCard.querySelector('[data-sk-book-stack-frame]');
          if (lastSpread) {
            var spreadBottom = lastSpread.getBoundingClientRect().bottom;
            dock = spreadBottom + navHeight <= window.innerHeight + 2;
          }
        }

        if (dock) {
          nav.classList.remove('is-floating');
          nav.classList.add('is-docked');
        } else {
          nav.classList.add('is-floating');
          nav.classList.remove('is-docked');
        }
      }

      navItems.forEach(function (item) {
        if (!item.hasAttribute('data-sk-book-anchor')) return;

        item.addEventListener('click', function (event) {
          var targetId = item.getAttribute('data-chapter');
          var target = targetId ? document.getElementById(targetId) : null;
          if (!target) return;

          event.preventDefault();
          var headerTop = parseFloat(getComputedStyle(stack).getPropertyValue('--sk-book-stack-header-top')) || 0;
          var top = target.getBoundingClientRect().top + window.pageYOffset - headerTop;

          window.scrollTo({
            top: top,
            behavior: reducedMotion ? 'auto' : 'smooth'
          });

          navItems.forEach(function (link) {
            link.classList.remove('is-active');
          });
          item.classList.add('is-active');
        });
      });

      if ('IntersectionObserver' in window && navItems.length && cards.length) {
        var headerTop = parseFloat(getComputedStyle(stack).getPropertyValue('--sk-book-stack-header-top')) || 0;
        var navHeightForObserver = nav ? nav.offsetHeight : 0;
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
              var id = entry.target.id;
              navItems.forEach(function (link) {
                link.classList.toggle('is-active', link.getAttribute('data-chapter') === id);
              });
            });
          },
          {
            root: null,
            rootMargin: '-' + headerTop + 'px 0px -' + navHeightForObserver + 'px 0px',
            threshold: [0.35, 0.55]
          }
        );

        cards.forEach(function (card) {
          observer.observe(card);
        });
      }

      updateBookStackNav();

      if (reducedMotion || cards.length < 2) {
        window.addEventListener('scroll', updateBookStackNav, { passive: true });
        window.addEventListener('resize', updateBookStackNav, { passive: true });
        return;
      }

      var ticking = false;

      function updateBookStack() {
        ticking = false;
        updateBookStackNav();
        var viewport = window.innerHeight;
        var topOffset = parseFloat(window.getComputedStyle(stack).getPropertyValue('--sk-book-stack-top')) || 0;

        cards.forEach(function (card, index) {
          var frame = card.querySelector('[data-sk-book-stack-frame]');
          if (!frame) return;

          var nextCard = cards[index + 1];
          if (!nextCard) {
            frame.style.transform = 'scale(1)';
            return;
          }

          var nextTop = nextCard.getBoundingClientRect().top - topOffset;
          var progress = 1 - Math.min(1, Math.max(0, nextTop / Math.max(viewport - topOffset, 1)));
          var scale = 1 - progress * 0.028;
          var translate = progress * -6;
          frame.style.transform = 'translate3d(0, ' + translate.toFixed(2) + 'px, 0) scale(' + scale.toFixed(4) + ')';
        });
      }

      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(updateBookStack);
        },
        { passive: true }
      );

      window.addEventListener('resize', function () {
        measureBookStackNav();
        updateBookStack();
      }, { passive: true });
      updateBookStack();
    });
  }

  /* ==========================================================================
     Kokulu Mum — marquee gallery lightbox
     ========================================================================== */

  var SK_KOKULU_GALLERY = '[data-sk-kokulu-gallery]';

  function createSkKokuluMarqueeItem(src, index, interactive, galleryLabel) {
    var img = document.createElement('img');
    img.alt = '';
    img.width = 666;
    img.height = 1000;
    img.decoding = 'async';
    img.draggable = false;
    // Keep clones and off-screen cycles from requesting assets on first paint.
    img.loading = 'lazy';
    img.src = src;

    if (interactive) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'SkKokulu__marqueeItem';
      btn.setAttribute('data-sk-kokulu-gallery-item', '');
      btn.setAttribute('data-index', String(index));
      btn.setAttribute('aria-label', galleryLabel + ' — ' + (index + 1));
      btn.appendChild(img);
      return btn;
    }

    var div = document.createElement('div');
    div.className = 'SkKokulu__marqueeItem SkKokulu__marqueeItem--clone';
    div.setAttribute('aria-hidden', 'true');
    div.appendChild(img);
    return div;
  }

  function fillSkKokuluMarqueeTrack(gallery, images, galleryLabel) {
    var track = gallery.querySelector('.SkKokulu__marqueeTrack');
    if (!track || !images.length) return;

    var marqueeWidth = gallery.getBoundingClientRect().width || gallery.offsetWidth || window.innerWidth;
    var gapValue = parseFloat(window.getComputedStyle(track).gap);
    var gap = isNaN(gapValue) ? 14.4 : gapValue;
    var probe = createSkKokuluMarqueeItem(images[0], 0, true, galleryLabel);
    probe.style.visibility = 'hidden';
    track.appendChild(probe);

    var itemWidth = probe.getBoundingClientRect().width;
    track.removeChild(probe);

    if (!itemWidth) {
      itemWidth = (parseFloat(window.getComputedStyle(probe).height) || 200) * 0.666;
    }

    var cycleWidth = images.length * itemWidth + Math.max(0, images.length - 1) * gap;
    var minCycles = Math.max(1, Math.ceil(marqueeWidth / cycleWidth));
    var maxCycles = Math.max(minCycles, 16);
    var cycle = 0;

    track.innerHTML = '';

    do {
      images.forEach(function (src, index) {
        track.appendChild(createSkKokuluMarqueeItem(src, index, cycle === 0, galleryLabel));
      });
      cycle += 1;
    } while (cycle < minCycles && cycle < maxCycles);

    var firstHalf = Array.prototype.slice.call(track.children);
    firstHalf.forEach(function (item) {
      var src = item.querySelector('img');
      if (!src) return;
      track.appendChild(createSkKokuluMarqueeItem(src.src, 0, false, galleryLabel));
    });
  }

  function refillSkKokuluMarquees() {
    document.querySelectorAll(SK_KOKULU_GALLERY + '[data-sk-kokulu-gallery-init]').forEach(function (gallery) {
      var section = gallery.closest('.SkKokulu');
      if (!section) return;

      var dataEl = section.querySelector('[data-sk-kokulu-gallery-data]');
      if (!dataEl) return;

      var images = [];
      try {
        images = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }
      if (!images.length) return;

      var galleryLabel = gallery.getAttribute('data-sk-gallery-label') || 'Gallery';
      fillSkKokuluMarqueeTrack(gallery, images, galleryLabel);
    });
  }

  function initSkKokuluGallery(scope) {
    var root = scope || document;
    var galleries = root.querySelectorAll(SK_KOKULU_GALLERY + ':not([data-sk-kokulu-gallery-init])');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
      var section = gallery.closest('.SkKokulu');
      if (!section) return;

      var dataEl = section.querySelector('[data-sk-kokulu-gallery-data]');
      var lightbox = section.querySelector('[data-sk-kokulu-lightbox]');
      if (!dataEl || !lightbox) return;

      var images = [];
      try {
        images = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }
      if (!images.length) return;

      var galleryLabel = gallery.getAttribute('data-sk-gallery-label') || 'Gallery';
      fillSkKokuluMarqueeTrack(gallery, images, galleryLabel);

      var imgEl = lightbox.querySelector('.SkKokuluLightbox__img');
      var countEl = lightbox.querySelector('[data-sk-kokulu-lightbox-count]');
      var prevBtn = lightbox.querySelector('[data-sk-kokulu-lightbox-prev]');
      var nextBtn = lightbox.querySelector('[data-sk-kokulu-lightbox-next]');
      var closeEls = lightbox.querySelectorAll('[data-sk-kokulu-lightbox-close]');
      var currentIndex = 0;
      var lastFocus = null;

      function renderSlide(index) {
        currentIndex = (index + images.length) % images.length;
        imgEl.src = images[currentIndex];
        imgEl.alt = '';
        if (countEl) {
          countEl.textContent = currentIndex + 1 + ' / ' + images.length;
        }
      }

      function closeLightbox() {
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        lightbox.classList.remove('is-open');
        gallery.classList.remove('is-lightbox-open');
        document.documentElement.classList.remove('sk-kokulu-lightbox-open');
        document.removeEventListener('keydown', onLightboxKeydown);
        imgEl.removeAttribute('src');
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus();
        }
      }

      function onLightboxKeydown(event) {
        if (lightbox.hidden) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          renderSlide(currentIndex - 1);
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          renderSlide(currentIndex + 1);
        }
      }

      function openLightbox(index) {
        lastFocus = document.activeElement;
        renderSlide(index);
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        lightbox.classList.add('is-open');
        gallery.classList.add('is-lightbox-open');
        document.documentElement.classList.add('sk-kokulu-lightbox-open');
        document.addEventListener('keydown', onLightboxKeydown);
        if (closeEls[0]) closeEls[0].focus();
      }

      gallery.addEventListener('click', function (event) {
        var item = event.target.closest('[data-sk-kokulu-gallery-item]');
        if (!item || !gallery.contains(item)) return;

        var index = parseInt(item.getAttribute('data-index'), 10);
        if (isNaN(index)) return;
        openLightbox(index);
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          renderSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          renderSlide(currentIndex + 1);
        });
      }

      closeEls.forEach(function (el) {
        el.addEventListener('click', closeLightbox);
      });

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox.querySelector('.SkKokuluLightbox__backdrop')) {
          closeLightbox();
        }
      });

      gallery.setAttribute('data-sk-kokulu-gallery-init', 'true');
    });
  }

  /* ==========================================================================
     Bootstrap
     ========================================================================== */

  var resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      syncSkHeaderResponsiveState();
      onGenderScrollResize();
      initEsarpCollageImages();
      initCollageFocalImages();
      refillSkKokuluMarquees();
      document.querySelectorAll(FLICKITY_SECTION).forEach(function (section) {
        var el = getFeaturedActiveCarouselEl(section);
        if (el) syncFeaturedCarousel(section, el);
      });
    }, 120);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGenderScrollSections();
    initFeaturedCarousels();
    bindDeferredImagePanels();
    initProductAlternateImages();
    initSkReveal();
    initEsarpCollageImages();
    initCollageFocalImages();
    initBackgroundVideoGuards();
    initSkYoutubeIframeLazy();
    initSkMegaMenu();
    initSkMegaMenuNavGuard();
    syncSkHeaderResponsiveState();
    watchSkHeaderSingleRowLayout();
    initSkStoresPage();
    initSkAboutPage();
    initSkBookStack();
    initSkContactPage();
    initSkKokuluGallery();
    trimRecentlyViewedProducts();
    initSkCollectionAddToCart();
    initSkCollectionFilterPopover();
    initRedundantNavigationGuard();
    window.addEventListener('resize', onResize);
    if (typeof SK_HEADER_DESK_MQ.addEventListener === 'function') {
      SK_HEADER_DESK_MQ.addEventListener('change', syncSkHeaderResponsiveState);
    } else if (typeof SK_HEADER_DESK_MQ.addListener === 'function') {
      SK_HEADER_DESK_MQ.addListener(syncSkHeaderResponsiveState);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initGenderScrollSections(event.target);
    initFeaturedCarousels(event.target);
    bindDeferredImagePanels(event.target);
    initProductAlternateImages(event.target);
    initSkReveal(event.target);
    initEsarpCollageImages(event.target);
    initCollageFocalImages(event.target);
    initBackgroundVideoGuards(event.target);
    initSkYoutubeIframeLazy(event.target);
    if (event.target.querySelector(SK_MEGA_MENU) || event.target.matches('.shopify-section--header')) {
      initSkMegaMenu(event.target);
      initSkMegaMenuNavGuard(event.target);
    }
    initSkStoresPage(event.target);
    initSkAboutPage(event.target);
    initSkBookStack(event.target);
    initSkContactPage(event.target);
    initSkKokuluGallery(event.target);
    initSkCollectionFilterPopover(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.matches('.shopify-section--header')) {
      delete event.target.dataset.skMegaNavGuard;
    }
    event.target.querySelectorAll(BACKGROUND_VIDEO_SECTION).forEach(destroyBackgroundVideoGuard);
    event.target.querySelectorAll(GENDER_SECTION).forEach(function (section) {
      delete section.dataset.skGenderInit;
    });
    event.target.querySelectorAll(FLICKITY_SECTION).forEach(function (section) {
      delete section.dataset.skFeaturedInit;
    });
    destroyFeaturedCarousels(event.target);
  });
})();


(function () {
  function labelProductDots(root) {
    (root || document).querySelectorAll('.Product__SlideshowMobileNav .flickity-page-dots').forEach(function (nav) {
      var template = nav.getAttribute('data-sk-dot-label') || '{{ number }}. görsele git';
      nav.querySelectorAll('.dot').forEach(function (button, index) {
        if (button.getAttribute('aria-label')) return;
        var n = index + 1;
        button.setAttribute(
          'aria-label',
          template.replace('NUM', String(n)).replace('{{ number }}', String(n)).replace('{{number}}', String(n))
        );
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      labelProductDots();
    });
  } else {
    labelProductDots();
  }

  document.addEventListener('shopify:section:load', function (event) {
    labelProductDots(event.target);
  });
})();
